import React, { useContext, useReducer, useEffect, useMemo } from 'react'
import useVisibility from '../Utils/isVisible';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Table, { TableHookPro } from '../Table';
import { Box, TextField } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Typography from '@mui/material/Typography';
import { lockedReducer } from '../Utils/reducers';
import ColorButton from '../Buttons/ColorButton';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { IconButton } from '@mui/material';
import MegaAutoComplete from '../Utils/megautocomplete';
import { externalComponent } from '../AppRoutes';
import { api } from '../../services/api';
import toast from 'react-hot-toast';
import { formatCurrency, formatDate } from '../Utils/IntegerOnly';

import { convertDateFormat } from '../Utils/functions';
import { number2dayweek } from '../Utils/dayjsptbrhelper';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const getcolumnsContasAPagar = (transferAPagar, state, setState) => {
    const columns = []
    columns.push({
        field: 'numero', headerName: 'Contas a Pagar', flex: 0.1, width: 100,
    })
    columns.push({ field: 'transportadora', headerName: 'Transportadora', flex: 0.1, width: 100 })
    columns.push({ field: 'empresa', headerName: 'Empresa', flex: 0.1, width: 100 })
    columns.push({
        field: 'dataemissao', headerName: 'Chegada', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.dataemissao)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'datavencimento', headerName: 'Vencimento', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.datavencimento)}
                </Box>
            )
        }
    })
    columns.push({ field: 'Status', headerName: 'Status', flex: 0.1, width: 100 })
    columns.push({ field: 'numeronota', headerName: 'Nota Venda', flex: 0.1, width: 100 })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 70,
        renderCell: (props) => {
            return (
                <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={() => transferAPagar(props.row, state, setState)}><ArrowCircleRightIcon sx={{ color: '#479760', transform: 'rotate(90deg)' }} className='arrowIcon' /></IconButton>
                </Box>
            )
        }
    })
    return columns
}

const getcolumnsBoletos = (state, setState) => {
    const columns = []
    columns.push({
        field: 'Numero', headerName: 'Contas a Pagar', flex: 0.1, width: 100,
    })
    columns.push({
        field: 'DataEmissao', headerName: 'Chegada', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.DataEmissao)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'DataVencimento', headerName: 'Vencimento', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.DataVencimento)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'Valor', headerName: 'Valor', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(row.Valor)}
                </Box>
            )
        }
    })
    columns.push({ field: 'Movimento', headerName: 'Movimento', flex: 0.1, width: 100 })
    columns.push({ field: 'Situação', headerName: 'Situação', flex: 0.1, width: 100 })
    return columns
}

const getcolumnsContasAPagarConhecimentos = (state, setState, transferAssociado) => {
    const columns = []
    columns.push({
        field: 'numero', headerName: 'Contas a Pagar', flex: 0.1, width: 100,
    })
    columns.push({
        field: 'dataemissao', headerName: 'Chegada', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.dataemissao)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'datavencimento', headerName: 'Vencimento', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.datavencimento)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'valor', headerName: 'Valor', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(row.valor)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 70,
        renderCell: (props) => {
            return (
                <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <IconButton onClick={() => transferAssociado(props.row, state, setState)}><ArrowCircleRightIcon sx={{ color: '#a14949', transform: 'rotate(270deg)' }} className='arrowIcon' /></IconButton>
                </Box>
            )
        }
    })
    return columns
}


const transferAPagar = (row, state, setState) => {


    if (state.disabledTable == false) {
        const aPagar = state.rowsContasAPagar.filter(item => item.id !== row.id)

        const associados = [
            ...state.rowsContasAPagarCTE.filter(item => item.id !== row.id),
            row
        ]

        setState({
            rowsContasAPagarCTE: associados,
            rowsContasAPagar: aPagar
        })

    } else {
        toast.error('Primeiramente selecione um boleto para associar!')
    }


}

const transferAssociado = (row, state, setState) => {


    const associados = state.rowsContasAPagarCTE.filter(item => item.id !== row.id)

    const aPagar = [
        ...state.rowsContasAPagar.filter(item => item.id !== row.id),
        row
    ]

    setState({
        rowsContasAPagarCTE: associados,
        rowsContasAPagar: aPagar
    })

}



const selectTipo = {
    1: {
        "nome": "Sem Boleto",
        "id": "1",
    },
    2: {
        "nome": "Com Boleto",
        "id": "2",
    }
}

const selectCondicao = {
    1: {
        "nome": "Pago",
        "id": "1",
    },
    2: {
        "nome": "Não pago",
        "id": "2",
    }
}

const setInicialDate = (e, setState) => {
    const value = e.format('YYYY-MM-DD')
    setState({ dtIni: value });
}

const setFinalDate = (e, setState) => {
    const value = e.format('YYYY-MM-DD')
    setState({ dtFim: value });
}

const getContasAPagar = async (setLoader, setState, data) => {
    setLoader(true)
    const res = await api.post('/frete/contas_a_pagar', data)
    if (res.status === 200) {
        setState({ rowsContasAPagar: res.data, rowsContasAPagarReset: res.data })
    }
    setLoader(false)
}

const getBoletosConsolidacao = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.post('/frete/boletos_consolidacao')
    if (res.status === 200) {
        setState({ rowsBoletos: res.data })
    }
    setLoader(false)
}

const createAssociacao = async (setLoader, setState, state) => {
    const obj = {
        id_boleto: state.idBoleto,
        rows: state.rowsContasAPagarCTE
    }

    if (state.disabledTable === false) {
        setLoader(true)
        const res = await api.post('/frete/boletos_associados', obj)
        if (res.status === 200) {
            getContasAPagar(setLoader, setState, state)
            toast.success('Associado com sucesso!')
        }
        setLoader(false)
    } else {
        toast.error('Selecione um boleto para associar!')
    }

}

const getAssociados = async (setLoader, setState, idBoleto) => {
    setLoader(true)
    const res = await api.get(`/frete/boletos_associados/${idBoleto}`)
    if (res.status === 200) {

        setState({ rowsContasAPagarCTE: res.data })
    }
    setLoader(false)
}

const clearFilter = (setLoader, setState, state, getContasAPagar) => {
    const data = { ...state, empresaFilter: '', contaAPagarFilter: '', transportadoraFilter: '', dtIni: '', dtFim: '' }
    setState(data)
    getContasAPagar(setLoader, setState, data)
}

const handleRowClick = (params, setState, state, setLoader) => {

    setState({ disabledTable: false, idBoleto: params.id, rowsContasAPagar: state.rowsContasAPagarReset, rowsContasAPagarCTE: [] })
    getAssociados(setLoader, setState, params.id)
};


const BoletoConhecimento = () => {

    const currentDate = new Date();
    const threeMonthsAgo = new Date();

    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth());

    threeMonthsAgo.setDate(1);

    const dtIni = convertDateFormat(threeMonthsAgo)
    const dtFim = convertDateFormat(currentDate)

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        rowsContasAPagar: [],
        rowsContasAPagarReset: [],
        rowsBoletos: [],
        rowsContasAPagarCTE: [],

        tipoFilter: '1',
        condicaoFilter: '2',
        empresaFilter: '',
        contaAPagarFilter: '',
        transportadoraFilter: '',
        dtIni: dtIni,
        dtFim: dtFim,
        rowsReset: [],

        disabledTable: true,
        idBoleto: null,

        paginationModel: { page: 0, pageSize: 20 },
        totalConhecimentos: 0,
        next: null

    })

    const [tableContasAPagarConhecimentos] = TableHookPro()
    const [tableBoletos] = TableHookPro()
    const [tableContasAPagarConhecimentosAssociados] = TableHookPro()

    useEffect(() => {
        getContasAPagar(setLoader, setState, state)
        getBoletosConsolidacao(setLoader, setState)
    }, [])

    return (
        <>
            <Box className='nfsentrada-mainframe' sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', minHeight: '1rem', height: '100%', overflow: 'auto', overflowX: 'hidden' }}>
                <Box className='nfsentrada-filters'>
                    <Box className='filter-items' sx={{ marginBottom: '2rem', alignItems: 'flex-end' }}>

                        <Box className='item-profile-row' sx={{ width: '9rem' }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Tipo"
                                    value={state.tipoFilter}
                                    onChange={(e) => setState({ 'tipoFilter': e.target.value })}
                                    sx={{ width: '9rem' }}
                                >

                                    {
                                        Object.entries(selectTipo).map(([key, value]) => (
                                            <MenuItem key={key} value={value.id}>{value.nome}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Box>

                        <Box className='item-profile-row' sx={{ width: '8rem' }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Condição</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Condição"
                                    value={state.condicaoFilter}
                                    onChange={(e) => setState({ 'condicaoFilter': e.target.value })}
                                >

                                    {
                                        Object.entries(selectCondicao).map(([key, value]) => (
                                            <MenuItem key={key} value={value.id}>{value.nome}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Box>

                        <Box className='item-profile-row' sx={{ width: '14rem' }} >
                            <MegaAutoComplete

                                id="conhecimentosFilial"
                                multiple={false}
                                value={state.empresaFilter}
                                onChange={(data) => { setState({ empresaFilter: data }) }}
                                noOptionsText={'Digite para procurar uma filial'}
                                timeoutUrl='/frete/filiais'
                                timeoutParam='label'
                                label='Empresa'
                            />
                        </Box>

                        <Box className='item-profile-row'>
                            <TextField
                                id="contaAPagarFilter"
                                type="text"
                                label="Contas a Pagar"
                                value={state.contaAPagarFilter}
                                onChange={(e) => { setState({ 'contaAPagarFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                            />
                        </Box>

                        <Box className='item-profile-row' sx={{ width: '14rem' }} >
                            <MegaAutoComplete

                                id="conhecimentosTransportadora"
                                multiple={false}
                                value={state.transportadoraFilter}
                                onChange={(data) => { setState({ transportadoraFilter: data }) }}
                                noOptionsText={'Digite para procurar uma transportadora'}
                                timeoutUrl='/frete/transportadoras'
                                timeoutParam='label'
                                label='Transportadora'
                            />
                        </Box>

                        <Box className='item-profile-row' sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>

                            <DemoContainer components={['DatePicker']} sx={{ width: '9.5rem', overflow: 'hidden' }}>
                                <DatePicker
                                    label="Dt emissão Inicial:"
                                    size="small"
                                    value={dayjs(state.dtIni)}
                                    onChange={(e) => setInicialDate(e, setState)}
                                    format='DD/MM/YYYY'
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            InputProps: {
                                                sx: {
                                                    paddingRight: '10px',
                                                    width: '9.5rem',
                                                },
                                            },
                                        },
                                    }}
                                />
                            </DemoContainer>

                            <DemoContainer components={['DatePicker']} sx={{ width: '9.5rem', overflow: 'hidden' }}>
                                <DatePicker
                                    label="Dt emissão Final:"
                                    size="small"
                                    value={dayjs(state.dtFim)}
                                    onChange={(e) => setFinalDate(e, setState)} format='DD/MM/YYYY'
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            InputProps: {
                                                sx: {
                                                    paddingRight: '10px',
                                                    width: '9.5rem',
                                                },
                                            },
                                        },
                                    }}
                                />
                            </DemoContainer>

                        </Box>

                    </Box>
                    <Box className='filter-buttons'>
                        <ColorButton onClick={() => getContasAPagar(setLoader, setState, state)}>Localizar</ColorButton>
                        <ColorButton onClick={() => clearFilter(setLoader, setState, state, getContasAPagar)}>Limpar filtros</ColorButton>
                    </Box>
                </Box>

                <Box sx={{ marginBottom: '1.5rem', height: '16rem' }}>
                    <Typography className='text-bold'>Contas a Pagar dos Conhecimentos:</Typography>
                    <Table
                        key='contas-a-pagar-dos-conhecimentos'
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rowsContasAPagar}
                        columns={useMemo(() => getcolumnsContasAPagar(transferAPagar, state, setState))}
                        rowHeight={30}
                        pro={true}
                        innerRef={tableContasAPagarConhecimentos}
                        nameTable='tableContasAPagarDosConhecimentos'
                        hideFooter={true}
                    />
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ColorButton onClick={() => createAssociacao(setLoader, setState, state)}>Salvar</ColorButton>
                </Box>

                <Box className='tables-container' sx={{ flex: .85, minHeight: 0 }}>

                    <Box className='table-section' >
                        <Typography className='text-bold'>{'Boletos (Consolidação dos CPs Conhecimento):'}</Typography>
                        <Table
                            key='boletos-consolidacao'
                            paginationMode='client'
                            className='contabil-grid'
                            rows={state.rowsBoletos}
                            columns={useMemo(() => getcolumnsBoletos(state, setState))}
                            rowHeight={30}
                            pro={true}
                            innerRef={tableBoletos}
                            nameTable='tableBoletosConsolidacao'
                            sx={{
                                '& .MuiDataGrid-row': {
                                    cursor: 'pointer',
                                },
                            }}
                            hideFooter={true}
                            onRowClick={(e) => handleRowClick(e, setState, state, setLoader)}
                        />
                    </Box>
                    <Box className='table-section'>
                        <Typography className='text-bold'>Contas a Pagar dos Conhecimentos - Associados ao Boleto:</Typography>
                        <Table
                            key='contas-a-pagar-conhecimentos-associados'
                            paginationMode='client'
                            className='contabil-grid'
                            rows={state.rowsContasAPagarCTE}
                            columns={useMemo(() => getcolumnsContasAPagarConhecimentos(state, setState, transferAssociado))}
                            rowHeight={30}
                            pro={true}
                            innerRef={tableContasAPagarConhecimentosAssociados}
                            nameTable='tableContasAPagarConhecimentosAssociados'
                            sx={{
                                filter: state.disabledTable ? 'blur(1px)' : 'none',
                                pointerEvents: state.disabledTable ? 'none' : 'auto',
                                opacity: state.disabledTable ? 1 : 1, // se quiser mudar a opacidade, altera aqui
                            }}
                            hideFooter={true}
                        />
                    </Box>
                </Box>

            </Box>
        </>
    )
}

export default BoletoConhecimento;